import { dateFromString } from '@retail/utils';
import { PriceControlSupplierDTO } from '../dto/PriceControlAggregatedDTO';

export class PriceControlSupplier {
  id: number;
  number: number;
  name: string;
  totalItemsInAssortment: number;
  firstUnhandledEventDate: Date;
  priceControlAmount: number;
  purchasePriceAverageDiffPercentage: number;
  purchasePriceAverageDiffAbsolute: number;
  salesPriceAverageDiffPercentage: number;
  salesPriceAverageDiffAbsolute: number;
  salesFactorAverageDiffPercentage: number;
  salesFactorMaxDiffPercentage: number;

  constructor({
    id,
    number,
    name,
    totalItemsInAssortment,
    firstUnhandledEventDate,
    priceControlAmount,
    purchasePriceAverageDiffPercentage,
    purchasePriceAverageDiffAbsolute,
    salesPriceAverageDiffPercentage,
    salesPriceAverageDiffAbsolute,
    salesFactorAverageDiffPercentage,
    salesFactorMaxDiffPercentage,
  }: PriceControlSupplier) {
    this.id = id;
    this.number = number;
    this.name = name;
    this.totalItemsInAssortment = totalItemsInAssortment;
    this.firstUnhandledEventDate = firstUnhandledEventDate;
    this.priceControlAmount = priceControlAmount;
    this.purchasePriceAverageDiffPercentage = purchasePriceAverageDiffPercentage;
    this.purchasePriceAverageDiffAbsolute = purchasePriceAverageDiffAbsolute;
    this.salesPriceAverageDiffPercentage = salesPriceAverageDiffPercentage;
    this.salesPriceAverageDiffAbsolute = salesPriceAverageDiffAbsolute;
    this.salesFactorAverageDiffPercentage = salesFactorAverageDiffPercentage;
    this.salesFactorMaxDiffPercentage = salesFactorMaxDiffPercentage;
  }

  static fromDto = (dto: PriceControlSupplierDTO): PriceControlSupplier =>
    new PriceControlSupplier({
      id: dto.supplierId,
      number: dto.supplierNumber,
      name: dto.supplierName,
      totalItemsInAssortment: dto.totalItemsFromSupplierInAssortment,
      firstUnhandledEventDate: dateFromString(dto.firstUnhandledEventDate)!,
      priceControlAmount: dto.suppliersItemsForPriceControlAmount,
      purchasePriceAverageDiffPercentage: dto.purchasePriceAverageDiffPercentage,
      purchasePriceAverageDiffAbsolute: dto.purchasePriceAverageDiffAbsolute,
      salesPriceAverageDiffPercentage: dto.salesPriceAverageDiffPercentage,
      salesPriceAverageDiffAbsolute: dto.salesPriceAverageDiffAbsolute,
      salesFactorAverageDiffPercentage: dto.salesFactorAverageDiffPercentage,
      salesFactorMaxDiffPercentage: dto.salesFactorMaxDiffPercentage,
    });
}
